/**
 * App
 *
 */
import Accordion from './accordion';
import Heights from './matchHeight';
import { Sliders } from './sliders';
import Filter from './filters';
import Menu from './menu';
import { Tabs } from "./tabs";
import Video from "./video";
import { Galleries } from './gallery/index';
import { Forms } from './forms';
import { Maps } from './map';

window.addEventListener('DOMContentLoaded', () => {
	Accordion();
	Heights();
	Sliders();
	Filter();
	Menu();
	Tabs();
	Video();
	Galleries();
	Forms();
	Maps();
})
